import { Link } from "react-router-dom";
import { Mail, Linkedin } from "lucide-react";

export const LINKEDIN_URL = "https://www.linkedin.com/in/lizkind1";

export default function Footer() {
  return (
    <footer className="border-t border-border bg-background mt-24">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <h3 className="font-cormorant text-2xl font-semibold text-foreground mb-2">Freelanceblogger</h3>
            <p className="font-manrope text-sm text-muted-foreground leading-relaxed">
              A newsletter for writers, marketers, and business owners who believe in the power of great words.
            </p>
            <div className="flex items-center gap-2 mt-4">
              <Mail size={15} className="text-brand-accent" />
              <a
                href="mailto:hello@freelanceblogger.club"
                className="font-manrope text-sm text-muted-foreground hover:text-brand-accent transition-colors duration-200"
              >
                hello@freelanceblogger.club
              </a>
            </div>
            <div className="flex items-center gap-2 mt-2">
              <Linkedin size={15} className="text-brand-accent" />
              <a
                href={LINKEDIN_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-linkedin-link"
                className="font-manrope text-sm text-muted-foreground hover:text-brand-accent transition-colors duration-200"
              >
                Connect on LinkedIn
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <p className="overline mb-4">Navigate</p>
            <ul className="space-y-2">
              {[
                { href: "/", label: "Home" },
                { href: "/subscribe", label: "Subscribe" },
                { href: "/referrals", label: "Refer & Earn" },
                { href: "/hire", label: "Hire Elizabeth" },
              ].map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="font-manrope text-sm text-muted-foreground hover:text-foreground transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
              <li>
                <a
                  href="https://freelanceblogger.club"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-manrope text-sm text-muted-foreground hover:text-foreground transition-colors duration-200"
                >
                  Portfolio Site
                </a>
              </li>
            </ul>
          </div>

          {/* Newsletter CTA */}
          <div>
            <p className="overline mb-4">Stay in the loop</p>
            <p className="font-manrope text-sm text-muted-foreground mb-4 leading-relaxed">
              Get writing tips, industry insights, and content strategies delivered to your inbox.
            </p>
            <Link
              to="/subscribe"
              data-testid="footer-subscribe-btn"
              className="inline-block px-5 py-2.5 rounded-full bg-brand-accent text-white text-sm font-medium font-manrope hover:bg-brand-accent-hover transition-colors duration-200"
            >
              Subscribe Free
            </Link>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-border flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-manrope text-xs text-muted-foreground">
            © {new Date().getFullYear()} Elizabeth Neal · Freelanceblogger. All rights reserved.
          </p>
          <Link
            to="/admin/login"
            className="font-manrope text-xs text-muted-foreground hover:text-foreground transition-colors duration-200"
          >
            Writer Login
          </Link>
        </div>
      </div>
    </footer>
  );
}
